export default __webpack_public_path__ + "static/media/UnableToSync.b80c8641.svg";